// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.admin') ? [] : [
    {
        path: 'objs-changes',
        name: consts.routerNames.object_changes.main,
        meta: {
            mainRouteName: consts.routerNames.object_changes.main,
            bodyGrid: "1X1",
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/admin/ObjectsChangesPage.vue')
    },
];

export default routes;